import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Modal from '@zr/components/Modal';

import './ScreenModal.less';

export function ScreenModal({
  children,
  isOpen,
  screenType,
}) {
  // Remove css class adds padding to the body element causing unwanted scroll behavior
  useEffect(() => {
    document.body.classList.remove('show_button_mobile_widget');
    return () => {
      document.body.classList.add('show_button_mobile_widget');
    };
  }, []);

  // We want to add the `screenType` to the `Modal.className` because there is currently only one case where
  // the `screenType` controls the CSS for a modal (`merge_parsed_resume_approval`)
  // `merge_parsed_resume_approval` class makes the modal larger than usual
  const modalClassName = `ScreenLayoutContainer ScreenModal ${screenType}`;

  return (
    <Modal
      bodyOpenClassName="ScreenModalBodyOpen"
      className={modalClassName}
      overlayClassName="ScreenModalOverlay"
      isOpen={isOpen}
    >
      {children}
    </Modal>
  );
}

ScreenModal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  isOpen: PropTypes.bool,
  screenType: PropTypes.string,
};

ScreenModal.defaultProps = {
  screenType: null,
  isOpen: true,
};


export default ScreenModal;
